import React, { Component } from 'react'

export default class Getreefertype extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          packagingType: [
            { key: "1", text: "OASIS 150 (12FT -20 D)", value: "1" },
            { key: "2", text: "SUPRA 550 (14FT - 20 D)", value: "2" },
            { key: "3", text: "OASIS 250 (20FT -20 D)", value: "3" },
            { key: "4", text: "SUPRA 850 (22FT-20 D)", value: "4" },
            { key: "5", text: "OASIS 350 (25FT - 20 D)", value: "5" },
            { key: "6", text: "SUPRA 1150 (32 FT - 20 D)", value: "6" },
            { key: "7", text: "SUPRA 1250 (34 FT - 20 D)", value: "7" },
            { key: "8", text: "HT-50 MINI (8FT 0 D)", value: "8" },
            { key: "9", text: "HT-100 (8FT -20 D)", value: "9" },
            { key: "10", text: "HT-250 (10FT -20 D)", value: "10" },
            { key: "11", text: "HT-250 SP 2 (20FT -20 D)", value: "11" },
            { key: "12", text: "HT-350 SP 2 (24FT -20 D)", value: "12" },
            { key: "13", text: "HT- 70 DWS (32FT -20 D)", value: "13" },
            { key: "14", text: "C150E (8FT-0 D)", value: "14" },
            { key: "15", text: "C250E (10FT-0 D)", value: "15" },
            { key: "16", text: "C350E (12FT-0 D)", value: "16" },
            { key: "17", text: "C450E (17FT-0D)", value: "17" },
            { key: "18", text: "V300 MAX 10 (8FT-20 D)", value: "18" },
            { key: "19", text: "V300 MAX 20 (8FT-20 D WITH STAND BY)", value: "19" },
            { key: "20", text: "V500 MAX 10 (10FT-20 D)", value: "20" },
            { key: "21", text: "V500 MAX 20 (10FT-20 D WITH STAND BY)", value: "21" },
            { key: "22", text: "RV 380 MAX 10 (10FT -20 D)", value: "22" },
            { key: "23", text: "RV 580 MAX 10 (12FT -20 D)", value: "23" },
            { key: "24", text: "T-600 (20FT -20 D)", value: "24" },
            { key: "25", text: "T-800 (24FT -20 D)", value: "25" },
            { key: "26", text: "T-1000 (32FT-20 D)", value: "26" },
            { key: "27", text: "T-1200 (34FT -20 D)", value: "27" },
          ],
          Name: "",
        };
      }

      async componentDidMount() {
        console.log(this.props.id);
        var name = this.state.packagingType.find(x => x.value == this.props.id);
        console.log(name);
        this.setState({
            Name: name
        })
      }

    render() {
        const { t } = this.props;
        const { Name } = this.state;
        return (
            <span>{Name ? Name.text : "NA"}</span>
        )
    }
}
